import React, {Component} from 'react';
import * as apis from '../../utils/apis';
import { connect } from "react-redux";
import DataGrid, {
    Column,
    Editing,
    Popup,
    Position,
    GroupPanel,
    FilterPanel,
    FilterRow,
    ColumnChooser,
    Scrolling,
    RequiredRule,
    FormItem,
    Lookup
} from 'devextreme-react/ui/data-grid';


const getHeight = () => {
    return (window.innerHeight - 48)
}

class BookingReasonStatusGrid extends Component {
    state = {
    };

    resize = () => {
        this.gridview.instance.option('height',getHeight());
      }
    
      componentDidMount() {
        window.addEventListener('resize', this.resize)
      }
      
      componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
      }

      setDefaultNewValues = (e) => {
          e.data.active = true;
      }

      onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: 'refresh',
              onClick: this.refreshGrid 
            }
          });
    }

    refreshGrid = () => {
        this.gridview.instance.refresh();
    }

    render() {
        return  (
            <DataGrid
            dataSource={apis.BookOffReasonStatusDataSource(this.props.user.access_token)}  
            noDataText="There are no booking to WO status maps defined."
            rowAlternationEnabled={true}  
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}  
            columnHidingEnabled={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            stateStoring={{ enabled: 'true',type: 'localStorage', storageKey: 'bookingReasonStatus' }}
            height={getHeight }
            width="100%" ref={(gv) => {this.gridview = gv}} 
            onInitNewRow={this.setDefaultNewValues} onToolbarPreparing={this.onToolbarPreparing}
            >
        <Scrolling mode="virtual" />
        <GroupPanel visible={true} />
        <FilterRow visible={true} />
        <FilterPanel visible ={true} />
        <Editing
            mode={'popup'}
            allowUpdating={this.props.grants.rights.adminBookingStatusMap}
            allowDeleting={this.props.grants.rights.adminBookingStatusMap}
            allowAdding={this.props.grants.rights.adminBookingStatusMap} >
             <Popup title={'Booking Reason / Status Map'} showTitle={true} width={700} height={345}>
              <Position my={'center'} at={'center'} of={window} />
            </Popup>
        </Editing>
  
        <ColumnChooser enabled={true} />
        {/* <StateStoring enabled={true} storageKey="this.props.sectionId" /> */}

        <Column dataField={'id'} visible={false}>
            <FormItem visible={false} />
        </Column>
        <Column dataField={'bookOffReasonId'} caption='Reason' >
            <RequiredRule />
            <Lookup dataSource={apis.BookOffReasonDataSource(this.props.user.access_token)} displayExpr={'reasonText'} valueExpr={'id'} />
        </Column>
        <Column dataField={'workOrderStatusId'} caption='Change Status to'>
            <RequiredRule />
            <Lookup dataSource={apis.WorkorderStatusDataSource(this.props.user.access_token)} displayExpr={'status'} valueExpr={'id'} />
        </Column>
     
       
 
        </DataGrid>
        );
    }


}


const mapStateToProps = (state) => {
    return {
        user: state.oidc.user,
        grants: state.rights
    };
  }


export default connect(mapStateToProps, null)(BookingReasonStatusGrid)